/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './concept-terms.reducer';

export const ConceptTermsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const conceptTermsEntity = useAppSelector(state => state.conceptTerms.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="conceptTermsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.conceptTerms.detail.title">ConceptTerms</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.id">Id</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.id}</dd>
          <dt>
            <span id="cui">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.cui">Cui</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.cui}</dd>
          <dt>
            <span id="lat">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.lat">Lat</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.lat}</dd>
          <dt>
            <span id="sab">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.sab">Sab</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.sab}</dd>
          <dt>
            <span id="tty">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.tty">Tty</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.tty}</dd>
          <dt>
            <span id="str">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.str">Str</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.str}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.code">Code</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.code}</dd>
          <dt>
            <span id="sty">
              <Translate contentKey="tinyMedicRestApp.conceptTerms.sty">Sty</Translate>
            </span>
          </dt>
          <dd>{conceptTermsEntity.sty}</dd>
        </dl>
        <Button tag={Link} to="/concept-terms" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/concept-terms/${conceptTermsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConceptTermsDetail;
